var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7986 7.50164L6.10619 1.23138C5.88623 0.990084 5.59961 0.933175 5.33632 1.08114C5.16079 1.18016 5.04192 1.35089 5.01192 1.55007C4.97637 1.77202 5.05081 2.00307 5.21522 2.18518C6.3817 3.47133 7.54818 4.75748 8.71688 6.04249L8.87352 6.21549C9.41232 6.80962 9.95113 7.40376 10.4966 8.00016C10.3699 8.13902 10.2444 8.27788 10.1189 8.41674L5.8729 13.089C5.63627 13.3496 5.39853 13.608 5.16968 13.8755C4.92638 14.1555 4.94749 14.5857 5.21522 14.8327C5.3352 14.9454 5.4774 15 5.62071 15C5.79624 15 5.97399 14.9192 6.11952 14.7587L11.7831 8.5169C11.8775 8.41332 12.0041 8.24715 11.9997 8.00358C12.0052 7.82375 11.9375 7.65529 11.7986 7.50164Z",
    fill: "#291482"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/right-arrow-icon.1a8125a2459ac54b8a2434d2f5806ae1.svg";
export { ForwardRef as ReactComponent };